/* global Swiper */
document.querySelectorAll( '.b-realization-carousel' ).forEach( ( block ) => {

	new Swiper( block, {
		slidesPerView: 1,
		spaceBetween: 6,
		loop: block.dataset.loop !== 'disable',
		navigation: {
			nextEl: '.btn--swipe-arrow-right',
			prevEl: '.btn--swipe-arrow-left',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		on: {
			init: handleInit,
			slideChange: handleSlideChange,
		},
	} );

	/**
	 * Updates the tabindex for links in visible and hidden slides
	 * @param {Swiper} swiper Swiper instance
	 */
	function updateTabIndex( swiper ) {

		swiper.slides.forEach( ( slide ) => {

			const links = slide.querySelectorAll( 'a' );
			if ( slide.classList.contains( 'swiper-slide-active' ) ) {

				links.forEach( ( link ) => {

					link.setAttribute( 'tabindex', '0' );

				} );

			} else {

				links.forEach( ( link ) => {

					link.setAttribute( 'tabindex', '-1' );

				} );

			}

		} );

	}

	/**
	 * Handler dla zdarzenia init
	 */
	function handleInit() {

		updateTabIndex( this );

	}

	/**
	 * Handler dla zdarzenia slideChange
	 */
	function handleSlideChange() {

		updateTabIndex( this );

	}

} );
